import animTransFadeIn from './fade/in'
import animTransFadeOut from './fade/out'
import animTransSlideIn from './slide/in'
import animTransSlideOut from './slide/out'

export {
  animTransFadeIn,
  animTransFadeOut,
  animTransSlideIn,
  animTransSlideOut
}
